module.exports = __webpack_public_path__ + "img/river-rock-walk.96134e4e.jpg";